"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const utils_1 = require("../../utils");
const DropdownStyled_1 = __importDefault(require("./DropdownStyled"));
const Message_1 = require("../message/Message");
const PosaRedeemActions_1 = __importDefault(require("../../actions/PosaRedeemActions"));
const PosaTemplate_1 = __importDefault(require("./PosaTemplate"));
const RedeemSectionPsnCountryContainer_1 = __importDefault(require("./RedeemSectionPsnCountryContainer"));
const RedeemSectionLoggedInStyled_1 = __importDefault(require("./RedeemSectionLoggedInStyled"));
const Tooltip_1 = __importDefault(require("./Tooltip"));
const classnames_1 = __importDefault(require("classnames"));
const window_or_global_1 = __importDefault(require("window-or-global"));
const next = () => {
    window_or_global_1.default.scrollTo(0, 0);
    PosaRedeemActions_1.default.setShowConfirm(true);
};
const platformSelection = ({ value }) => PosaRedeemActions_1.default.setPlatform(value);
const VerifiedCodeSection = ({ data, posaRedeemStore, accountName }) => {
    const { platform, code, psnCountry, externalAuths, page: { configs: { psnOptions, enableRegionAutoDetection, extra } }, offer, codeVerified, connectedPlatforms = [] } = posaRedeemStore;
    const { bgImage, moneyImage, loggedInContent, inputPlaceholder, toolTipDescription, toolTipImage, platformToolTip, psnToolTip } = data;
    const platformOptions = react_1.default.useMemo(() => utils_1.generatePlatformOptions(externalAuths, Message_1.localizedMessage, connectedPlatforms), [
        externalAuths,
        connectedPlatforms
    ]);
    const countries = react_1.default.useMemo(() => {
        try {
            const countries = JSON.parse(psnOptions);
            if (countries)
                return countries;
        }
        catch (ex) {
            console.warn('VerifiedCodeSection: Unable to parse psnOptions');
        }
        return [];
    }, [psnOptions]);
    const style = react_1.default.useMemo(() => ({
        backgroundImage: `url(${bgImage})`
    }), [bgImage]);
    const image = codeVerified ? utils_1.getCardImage(offer) : moneyImage;
    const dropdownOptions = react_1.default.useMemo(() => platformOptions.map(op => {
        const { value, label, disabled, platformDisabled, hasExternalAuth } = op;
        return { value, label, disabled, disableMark: platformDisabled && hasExternalAuth ? '**' : '' };
    }), [platformOptions]);
    const extraTag = react_1.default.useMemo(() => {
        const hasNoneExternalAuth = platformOptions.find(op => !op.hasExternalAuth);
        const hasPlatformDisabled = platformOptions.find(op => op.platformDisabled && op.hasExternalAuth);
        return (react_1.default.createElement(react_1.Fragment, null,
            !!hasNoneExternalAuth && (react_1.default.createElement(PosaTemplate_1.default, { Tag: "div", isTemplate: true, className: "ecr-dropdown-row warning disabled", string: Message_1.localizedMessage('epic.code.redemption.posa.platform.authHelp') })),
            !!hasPlatformDisabled && (react_1.default.createElement(PosaTemplate_1.default, { Tag: "div", isTemplate: true, className: "ecr-dropdown-row warning disabled", string: Message_1.localizedMessage('epic.code.redemption.posa.platform.notRedeemable') }))));
    }, [platformOptions, extra]);
    return (react_1.default.createElement(RedeemSectionLoggedInStyled_1.default, { className: 'ecr-redeemSection verified', style: style },
        react_1.default.createElement("div", { className: "ecrrs-left" }, image && react_1.default.createElement("img", { src: image, alt: "card" })),
        react_1.default.createElement("div", { className: "ecrrs-right" },
            react_1.default.createElement("div", { className: "ecrrs-loggedIn verified" },
                react_1.default.createElement(PosaTemplate_1.default, { posaRedeemStore: posaRedeemStore, isTemplate: true, Tag: "div", string: loggedInContent, useDangerouslySetInnerHTML: true, accountName: accountName }),
                react_1.default.createElement("div", { className: "input-wrapper codeInput verified" },
                    react_1.default.createElement("input", { type: "text", placeholder: inputPlaceholder, value: code, disabled: true }),
                    react_1.default.createElement(Tooltip_1.default, { content: toolTipDescription, image: toolTipImage })),
                react_1.default.createElement("div", { className: "redeem-next next-select-platform" },
                    react_1.default.createElement("strong", null,
                        Message_1.localizedMessage('epic.code.redemption.posa.page.common.next'),
                        ":"),
                    react_1.default.createElement("span", null, Message_1.localizedMessage('epic.code.redemption.posa.page.redeem.next'))),
                react_1.default.createElement("div", { className: classnames_1.default('input-wrapper platformInput', { verified: platform }) },
                    react_1.default.createElement(DropdownStyled_1.default, { placeholder: Message_1.localizedMessage('epic.code.redemption.posa.page.redeem.next.placeholder'), options: dropdownOptions, extra: extraTag, callback: platformSelection }),
                    react_1.default.createElement(Tooltip_1.default, { content: platformToolTip, image: "" })),
                platform && platform === 'psn' ? (react_1.default.createElement(RedeemSectionPsnCountryContainer_1.default, { externalAuths: externalAuths, enableRegionAutoDetection: enableRegionAutoDetection, psnCountry: psnCountry, countries: countries, psnToolTip: psnToolTip, connectedPlatforms: connectedPlatforms })) : null,
                (platform && platform !== 'psn') || (platform && platform === 'psn' && psnCountry && !enableRegionAutoDetection) ? (react_1.default.createElement("div", { className: "confirm-next-section" },
                    react_1.default.createElement("button", { onClick: next }, Message_1.localizedMessage('epic.code.redemption.posa.page.common.next')),
                    react_1.default.createElement("span", null, Message_1.localizedMessage('epic.code.redemption.posa.page.redeem.confirm.next')))) : null))));
};
exports.default = VerifiedCodeSection;
//# sourceMappingURL=RedeemSectionVerifiedCode.js.map